// apps/client/src/components/dashboard/TableActionsBar.tsx
// ==========================================================================
// TABLE ACTIONS BAR — Color legend for column groups
// ==========================================================================
// Displays above the P&L table. Shows column group legend.
// Expand All / Collapse All buttons will be enabled in Phase 2 (drill-down).
// No CSV export button — ever.
// ==========================================================================

import React from 'react';

interface TableActionsBarProps {
  onExpandAll?: () => void;
  onCollapseAll?: () => void;
  hasBreakdown?: boolean;
}

const TableActionsBar: React.FC<TableActionsBarProps> = ({
  onExpandAll,
  onCollapseAll,
  hasBreakdown = false,
}) => {
  const enabled = hasBreakdown && !!onExpandAll && !!onCollapseAll;

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 py-2 px-4">
      {/* Color Legend */}
      <div className="flex flex-wrap items-center gap-4 text-xs text-gray-400">
        <div className="flex items-center gap-1.5">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-emerald-500" />
          <span>Commission (Flow)</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-amber-500" />
          <span>Book (Snapshot)</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-cyan-500" />
          <span>Activity (Flow)</span>
        </div>
      </div>

      {/* Expand/Collapse buttons — enabled when breakdown data available */}
      <div className="flex items-center gap-2">
        <button
          disabled={!enabled}
          className={`px-3 py-1 text-xs rounded-md transition-colors ${
            enabled
              ? 'bg-gray-700 text-gray-300 hover:bg-gray-600 cursor-pointer'
              : 'bg-gray-700 text-gray-500 cursor-not-allowed'
          }`}
          onClick={enabled ? onExpandAll : undefined}
        >
          Expand All
        </button>
        <button
          disabled={!enabled}
          className={`px-3 py-1 text-xs rounded-md transition-colors ${
            enabled
              ? 'bg-gray-700 text-gray-300 hover:bg-gray-600 cursor-pointer'
              : 'bg-gray-700 text-gray-500 cursor-not-allowed'
          }`}
          onClick={enabled ? onCollapseAll : undefined}
        >
          Collapse All
        </button>
      </div>
    </div>
  );
};

export default TableActionsBar;
